package com.shadowings.gero.presentation.component

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.hapticfeedback.HapticFeedbackType
import androidx.compose.ui.platform.LocalHapticFeedback
import androidx.compose.ui.semantics.semantics
import androidx.compose.ui.semantics.testTag
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.shadowings.gero.presentation.ui.AppTheme
import com.shadowings.gero.presentation.util.DevicePreviews
import com.shadowings.gero.presentation.util.rememberDeviceInfo

@DevicePreviews
@Preview
@Preview(name = "Dark", uiMode = 0x20, showBackground = true)
@Composable
private fun GeroButtonPreview() {
    AppTheme {
        Surface {
            GeroButton("Continua") {}
        }
    }
}

@Composable
fun GeroButton(
    enabled: Boolean = true,
    backgroundColor: Color = MaterialTheme.colorScheme.primaryContainer,
    borderColor: Color = MaterialTheme.colorScheme.primary,
    testTagId: String = "",
    textColor: Color = MaterialTheme.colorScheme.onSurface,
    modifier: Modifier = Modifier.width(300.dp),
    hapticFeedbackOnClick: Boolean = true,
    onClick: () -> Unit,
    content: @Composable () -> Unit
) {
    val hapticFeedback = LocalHapticFeedback.current
    val resolvedTestTag = testTagId.ifBlank { "default" }
    Button(
        onClick = {
            if (hapticFeedbackOnClick) {
                hapticFeedback.performHapticFeedback(HapticFeedbackType.LongPress)
            }
            onClick.invoke()
        },
        enabled = enabled,
        modifier = modifier
            .semantics { testTag = "gero_button_$resolvedTestTag" },
        border = BorderStroke(
            width = 1.dp,
            color = borderColor.copy(alpha = 0.5f)
        ),
        colors = ButtonDefaults.buttonColors(
            containerColor = backgroundColor,
            contentColor = textColor,
            disabledContainerColor = backgroundColor.copy(alpha = 0.5f),
            disabledContentColor = textColor.copy(alpha = 0.5f)
        ),
        shape = RoundedCornerShape(12.dp)
    ) {
        content()
    }
}

@Composable
fun GeroButton(
    title: String,
    enabled: Boolean = true,
    backgroundColor: Color = MaterialTheme.colorScheme.primaryContainer,
    textColor: Color = MaterialTheme.colorScheme.onSurface,
    borderColor: Color = MaterialTheme.colorScheme.primary,
    textStyle: TextStyle = MaterialTheme.typography.titleMedium.copy(
        fontSize = 18.sp,
        fontWeight = FontWeight.Bold
    ),
    testTagId: String = title,
    modifier: Modifier = Modifier.width(300.dp),
    hapticFeedbackOnClick: Boolean = true,
    onClick: () -> Unit
) {
    GeroButton(
        enabled = enabled,
        backgroundColor = backgroundColor,
        borderColor = borderColor,
        testTagId = testTagId,
        modifier = modifier,
        hapticFeedbackOnClick = hapticFeedbackOnClick,
        onClick = onClick,
        textColor = textColor
    ) {
        Text(
            text = title,
            style = textStyle,
            color = textColor,
            textAlign = TextAlign.Center
        )
    }
}
